module.exports = __webpack_public_path__ + "img/default-compic.9f8e728b.jpg";